const CmsThemeCategory = () =>
  import(
    /* webpackChunkName: "base-info-cms-theme-category" */ '@/pages/base-info/cms/theme-category/index.vue'
  )
const CreateCmsThemeCategory = () =>
  import(
    /* webpackChunkName: "base-info-cms-theme-category" */ '@/pages/base-info/cms/theme-category/create.vue'
  )
const EditCmsThemeCategory = () =>
  import(
    /* webpackChunkName: "base-info-cms-theme-category" */ '@/pages/base-info/cms/theme-category/edit.vue'
  )

export default {
  path: 'theme-category',
  meta: {
    label: 'themeCategory',
    auth: 'themeCategory'
  },
  component: {
    name: 'ThemeCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCmsThemeCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CmsThemeCategory
    },
    {
      name: 'BaseInfoCreateCmsThemeCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCmsThemeCategory
    },
    {
      name: 'BaseInfoEditCmsThemeCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCmsThemeCategory,
      props: true
    }
  ]
}
